import request from "./request";

const api = {
  getUserTokenList: "user_token/getUserTokenList",
};
export default {
  getUserTokenList(parameter) {
    return request({
      url: api.getUserTokenList,
      method: "POST",
      data: parameter,
    });
  },
};
